import Modal from 'styled-react-modal';

export const StyledModal = Modal.styled`
    width: 500px;
    height: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.white.main};
    border-radius: 5px;
    
    & p {
        font-size: 20px;
    }
`;
